import { useMutation } from '@tanstack/react-query';
import { axiosClient } from '@/utils/apiClient';
import { useWidgetConfig } from '.';
import { useSender } from './useSender';

export enum SmsContactFormErrorCode {
  RateLimitExceeded = 1001,
}
interface SmsContactFormResponse {
  message: string;
  errorCode?: SmsContactFormErrorCode.RateLimitExceeded;
  exitCode: number;
  isSuccess: boolean;
}

export class SmsContactFormError extends Error {
  constructor(
    message: string,
    public errorCode: SmsContactFormErrorCode,
  ) {
    super(message);
  }
}

export const useSmsContactForm = () => {
  const { senderId } = useSender();
  const channelIdentityId = useWidgetConfig().config?.channelIdentityId;

  return useMutation({
    mutationFn: async ({
      phoneNumber,
      message,
      isMarketingConsent,
    }: {
      phoneNumber: string;
      message: string;
      isMarketingConsent: boolean;
    }) => {
      const response = await axiosClient.post<SmsContactFormResponse>(
        `/LiveChatV2/Public/Senders/${senderId}/Channels/${channelIdentityId}/SmsContactForm`,
        { phoneNumber, message, isMarketingConsent },
      );

      if (response.data.isSuccess) {
        return response.data;
      } else {
        if (response.data.errorCode) {
          throw new SmsContactFormError(
            response.data.message,
            response.data.errorCode,
          );
        }
        throw new Error(response.data.message);
      }
    },
  });
};
